// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_40-0";
export var eligibilityCardNotEligible = "_40-1";